var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"w-100 salesflow-btn salesflow-btn-primary",attrs:{"disabled":_vm.success || _vm.submitting || _vm.disabled},on:{"click":() => _vm.$emit('advance')}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }